import { Select, SelectProps } from 'antd';
import { useGetAllImplementTypesQuery } from 'app/api';
import { FC } from 'react';
import { IOption } from 'types';

interface IProps extends SelectProps<number> {}

const ImplementTypeSelect: FC<IProps> = props => {
  const {
    data: allTransportTypes,
    isFetching,
  } = useGetAllImplementTypesQuery();

  const options: IOption[] | undefined = allTransportTypes?.map(
    tranportType => ({
      value: tranportType.id,
      label: tranportType.name,
    }),
  );
  return <Select options={options} loading={isFetching} {...props} />;
};

export default ImplementTypeSelect;
